export const KYC_API_EVENTS = {
  API_KYC_WEBSOCKET_GET_DATA_SUCCESS: 'api_kyc_websocket_get_data_success',
  API_KYC_WEBSOCKET_GET_DATA_ERROR: 'api_kyc_websocket_get_data_error',
  API_KYC_WEBSOCKET_GET_DATA_WITHOUT_DATA:
    'api_kyc_websocket_get_data_without_data',
  API_KYC_WEBSOCKET_GET_DATA_WITHOUT_STATE:
    'api_kyc_websocket_get_data_without_state',
  API_KYC_WEBSOCKET_KEEP_CONNECTION_OPEN:
    'api_kyc_websocket_keep_connection_open',
  API_KYC_CHANGE_STATE_FOR_UPLOAD_DOCUMENTS_SUCCESS:
    'api_kyc_change_state_for_upload_documents_success',
  API_KYC_CHANGE_STATE_FOR_UPLOAD_DOCUMENTS_ERROR:
    'api_kyc_change_state_for_upload_documents_error',
  API_KYC_IDV_CREATE_TOKEN_SUCCESS: 'api_kyc_idv_create_token_success',
  API_KYC_IDV_CREATE_TOKEN_ERROR: 'api_kyc_idv_create_token_error',
} as const;
